export default __webpack_public_path__ + "static/media/grape_icon.f6d52560.png";